export default __webpack_public_path__ + "static/media/img2.cbdc8fd7.png";